export const dadosIniciais = {
  id: 0,
  nome: '',
  nomeSocial: '',
  nomeMae: '',
  email: '',
  dataNascimento: '',
  dataNascimentoLabel: '',
  naturalidade: '',
  estadoNascimento: '',
  estadoNascimentoLabel: '',
  municipioNascimento: '',
  municipioNascimentoLabel: '',
  sexoBiologico: '',
  sexoBiologicoLabel: '',
  racaCor: '',
  racaCorLabel: '',
  identidadeGenero: '',
  identidadeGeneroLabel: '',
  estadoCivil: '',
  estadoCivilLabel: '',
  religiao: '',
  religiaoLabel: '',
  lateralidade: '',
  lateralidadeLabel: '',
  escolaridade: '',
  escolaridadeLabel: '',
  profissao: '',
  profissaoLabel: '',
  tipoTrabalho: '',
  tipoTrabalhoLabel: '',
  ultimasAtividadesProfissionais: '',
  condicaoAtual: '',
  condicaoAtualLabel: '',
  tempoCondicaoAtual: '',
  enderecoCep: '',
  enderecoUf: '',
  enderecoCodigoUf: '',
  enderecoMunicipio: '',
  enderecoIBGE: '',
  enderecoLogradouro: '',
  enderecoBairro: '',
  enderecoNumero: '',
  enderecoComplemento: '',
  numeroTelefone: [1],
  responsavelTelefone: [],
}